<template>
  <div class="mb-5" :class="{ 'px-4': windowWidth < 600, 'pl-2': windowWidth >= 900 }">
    <div class="row" v-for="(pRaza, i) in misDogs" :key="i">
      <div class="col-12">
        <div class="card my-1">
          <div class="card-header">
            <!-- raza -->
            {{
              pRaza[0].breed
                | filterTranslateBreed(
                  pRaza[0].breeds.id,
                  pRaza[0].breeds.translations,
                  $i18n.locale,
                  "name"
                )
            }}
          </div>
          <div
            class="card-body py-1"
            v-for="(perro, n) in pRaza"
            :key="perro.id"
          >
            <div class="row mb-1">
              <div class="col-12">
                <small>{{ perro.chip }}, {{ perro.birth }}</small>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger btn-gr float-right"
                  @click.prevent="deleteThisDog(perro)"
                >
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary btn-gr float-right mr-1"
                  @click.prevent="editThisDog(perro)"
                >
                  <i class="fa fa-edit" aria-hidden="true"></i>
                </button>
              </div>
              <div class="col-12">
                <small>
                  {{ perro.name }}
                  <i
                    class="font-weight-bold"
                    :class="perro.sex_id | sexIcon"
                    :title="perro.sex_id === 2 ? $t('macho') : $t('hembra')"
                  ></i>
                </small>
                <!-- botones documentos -->
                <div
                  class="btn-group float-right"
                  role="group"
                  aria-label="First group"
                >
                  <button
                    v-tooltip="{
                      content:
                        showDetail === true &&
                        showDetailIndex === `${n}_${perro.id}`
                          ? $t('ocultar')
                          : $t('mostrar'),
                    }"
                    type="button"
                    class="btn btn-outline-secondary btn-sm btn-gr"
                    @click="
                      showDetailChild(`${n}_${perro.id}`, 'Upload-file.vue')
                    "
                  >
                    <i
                      :class="
                        showDetail === true &&
                        showDetailIndex === `${n}_${perro.id}`
                          ? 'fa fa-eye-slash'
                          : 'fa fa-eye'
                      "
                      aria-hidden="true"
                    ></i>
                    {{ $t("documentos") }}
                  </button>

                  <button
                    v-tooltip="{ content: $t(tipo.name) }"
                    type="button"
                    class="btn btn-sm btn-gr"
                    v-for="tipo in tipoFicheros"
                    :key="tipo.id"
                    :class="
                      existeTipoFichero(perro.files, tipo.id)
                        ? 'existe-doc'
                        : ''
                    "
                  >
                    {{ tipo.name.substr(0, 1) }}
                  </button>
                </div>
              </div>
            </div>
            <!-- componente documentos -->
            <div
              class="row"
              v-if="
                showDetailIndex === `${n}_${perro.id}` && showDetail === true
              "
            >
              <div class="col-md-12">
                <transition name="fade">
                  <component
                    :is="component"
                    v-if="showDetail"
                    :dogId="perro.id"
                  />
                </transition>
              </div>
            </div>
            <hr class="my-0" v-if="n < pRaza.length - 1" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { mapGetters, mapActions, mapState } from "vuex";

/* import UploadDogFile from '@/components/layouts/general/Upload-dog-file'; */

export default {
  name: "dog-list",
  /*   components : { UploadDogFile }, */
  props: ["dogs", "callEditDog", "callDeleteDog"],
  data() {
    return {
      showDetailIndex: null,
      showDetail: false,
      component: null,
      tipoFiles: null,
      misDogs: {},
      windowWidth: 0,
    };
  },
  methods: {
    ...mapActions("files", ["getTypeDocList"]),
    /* funcion para comprobar si existe un documento de un perro */
    existeTipoFichero(ficheros, tipoId) {
      if (ficheros.length === 0) return false;
      const existe = ficheros.find((x) => x.doc_type_id === tipoId);
      if (existe !== undefined) return true;
    },
    showDetailChild: function (id, myComponent) {
      if (this.showDetail === true && this.showDetailIndex === id) {
        this.showDetail = false;
        this.component = null;
        return;
      }
      //this.component = () => import(`@/components/layouts/general/${myComponent}`);
      this.component = () => import("./Dog-documents");
      this.showDetailIndex = id;
      this.showDetail = true;
    },
    showUploadComp: function (id, type) {},
    editThisDog(dog) {
      this.callEditDog({
        objDog: dog,
      });
    },
    deleteThisDog(dog) {
      this.callDeleteDog({
        objDog: dog,
      });
    },
  },
  computed: {
    ...mapGetters("files", ["getTipoFiles"]),
    tipoFicheros: function () {
      if (this.tipoFiles !== null) {
        return this.tipoFiles.filter((x) => {
          if (x.relative_to === "dogs") {
            return x;
          }
        });
      }
    },
  },
  filters: {
    sexo: function (sexId) {
      return sexId == 1 ? "Macho" : "Hembra";
    },
    sexIcon: function (sexId) {
      return sexId == 1 ? "fa fa-mars text-success" : "fa fa-venus text-danger";
    },
  },
  mounted() {
    this.misDogs = _.groupBy(_.cloneDeep(this.dogs), "dog_breed_id");
    console.log(this.dogs, this.misDogs);
    this.getTypeDocList()
      .then((res) => (this.tipoFiles = this.getTipoFiles))
      .catch((error) => console.log);
    //controlamos el ancho de la ventana
    window.addEventListener("resize", () => {     
      this.windowWidth = window.innerWidth;
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>
<style scoped>
.dog_list {
  font-size: 12px !important;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.existe-doc {
  background-color: rgb(0, 199, 0);
  color: white;
}
</style>
